import { IFoodlaCategoryOption } from 'models/category';
import IProduct, { Org } from 'models/product';

export type ProductRuleFieldType = keyof IProduct | 'vitamins_minerals';

/** Same text as the base required fields (e.g. Produktnamn). */
export { MISSING_FIELD_ERROR } from 'generated/productRequirements/types';

export type ProductFieldValidatorParams = {
  field: ProductRuleFieldType;
  state?: IProduct;
  /** [recognizeImages]: product-information files that will remain after saving (saved minus removed plus new). */
  productInfoFilesCount?: number;
};

export type ProductFieldRuleType = {
  fields: ProductRuleFieldType[];
  label: string;
  /** Replaces "<label> är obligatoriskt" in the error label and under the field. */
  message?: string;
  organizations: 'base' | Org[];
  categoryCondition?: (params: {
    field: ProductRuleFieldType;
    state?: IProduct;
    rootCategory?: IFoodlaCategoryOption;
  }) => boolean;
  requireValidator?: (params: ProductFieldValidatorParams) => boolean;
  /** Support TreeView fields. */
  expandTreeViews?: { treeViewId: string; nodeId: string; forFields?: ProductRuleFieldType[] }[];
};

export type ProductValidationError = {
  /** First missing field of the rule; the error label scrolls to it. */
  field: ProductRuleFieldType;
  rule: ProductFieldRuleType;
  /** Retailers that require the rule; empty for base rules. */
  requiredBy: Org[];
  message: string;
};

export type ProductValidations = {
  /** Fields that must be filled for this product, mapped to the rule that requires them. */
  requiredFields: Partial<Record<ProductRuleFieldType, ProductFieldRuleType>>;
  /** One error per rule with at least one missing field. */
  errors: ProductValidationError[];
  /** Every required field that is still missing, with the text shown under it once the user has visited it. */
  missingFields: Partial<Record<ProductRuleFieldType, string>>;
};

export const EMPTY_PRODUCT_VALIDATIONS: ProductValidations = { requiredFields: {}, errors: [], missingFields: {} };
